
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1s22r_17",
  "full-width": "awsui_full-width_8cbea_1s22r_44",
  "refresh": "awsui_refresh_8cbea_1s22r_47",
  "disabled": "awsui_disabled_8cbea_1s22r_53",
  "selected": "awsui_selected_8cbea_1s22r_116",
  "icon": "awsui_icon_8cbea_1s22r_127",
  "with-text": "awsui_with-text_8cbea_1s22r_131",
  "with-no-text": "awsui_with-no-text_8cbea_1s22r_140",
  "root": "awsui_root_8cbea_1s22r_145",
  "segment-part": "awsui_segment-part_8cbea_1s22r_177",
  "grouped": "awsui_grouped_8cbea_1s22r_201",
  "grouped-only": "awsui_grouped-only_8cbea_1s22r_201",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_1s22r_205",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_1s22r_216",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_1s22r_220",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_1s22r_226",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_1s22r_230",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_1s22r_234",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_1s22r_240",
  "select": "awsui_select_8cbea_1s22r_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_1s22r_257",
  "segment-count-3": "awsui_segment-count-3_8cbea_1s22r_264",
  "segment-count-4": "awsui_segment-count-4_8cbea_1s22r_271",
  "segment-count-5": "awsui_segment-count-5_8cbea_1s22r_278",
  "segment-count-6": "awsui_segment-count-6_8cbea_1s22r_285",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1s22r_292"
};
  